import React from 'react';
import { Button } from '@naf-simba/elements-buttons';
import styled from '@emotion/styled';
import { resolveLinkProps } from '@lib/resolveLinkProps';
import { InternalGlobalCTAType } from './index';
import { useDocumentUrlWithNode } from '../../../../../../hooks/Documents/useDocumentUrl';
import useSelector from '../../../../../../redux/typedHooks';
import { useTrackCTA } from '../../../../../../utils/Tracking/CtaClick/TrackCtaClick';
import { useTrackPromotion } from '../../../../../../hooks/useTrackPromotion';
import { getPromotionEventTrackingData } from '../../../../../../utils/Tracking/Promotion/getPromotionEventTrackingData';

interface Props {
  data: InternalGlobalCTAType['data'];
}

export const InternalLink = ({ data }: Props) => {
  const baseUrl = useSelector((state) => state.application.baseUrl);
  const trackCTA = useTrackCTA();
  const referenceUrl = useDocumentUrlWithNode(data.internalLink) || '';
  const linkProps = resolveLinkProps({ url: referenceUrl, baseUrl, blank: data.blank });
  const promotion = getPromotionEventTrackingData(data.buttonText, referenceUrl);
  const shouldTrackPromotion = Boolean(promotion);
  const { wrapperRef, trackSelectPromotion } = useTrackPromotion({
    creative_slot: 'internal-link',
    creative_name: `CTA | ${data.buttonText}`,
    promotion_id: promotion?.promotion_id,
    promotion_name: promotion?.promotion_name,
  });

  const handleTracking = () => {
    if (shouldTrackPromotion) {
      trackSelectPromotion();
    }
    const urlObject = new URL(baseUrl);
    trackCTA({
      cta_position: 'content',
      text: data.buttonText,
      url: referenceUrl,
      cta_hostname: urlObject.hostname,
    });
  };

  return (
    <Wrapper ref={shouldTrackPromotion ? wrapperRef : undefined}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Button onClick={handleTracking} {...linkProps}>
        {data.buttonText}
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
`;
